import { Routes, Route, Navigate } from 'react-router-dom';
import { LinkPage, CompletePage, ErrorPage, SsoPage } from '@/pages';

function App() {
  return (
    <Routes>
      {/* メインの連携ページ */}
      <Route path="/" element={<LinkPage />} />

      {/* LINE SSOログインページ */}
      <Route path="/sso" element={<SsoPage />} />

      {/* 連携完了ページ */}
      <Route path="/complete" element={<CompletePage />} />

      {/* エラーページ */}
      <Route path="/error" element={<ErrorPage />} />

      {/* その他のパスはトップにリダイレクト */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
